module.exports = __webpack_public_path__ + "20195e2f81a982f03858ff3fb16772e0.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-4@2x.png
// module id = 521
// module chunks = 0